
import { defineComponent } from 'vue'

import BaseAlert from '@/components/BaseAlert.vue'

export default defineComponent({
  components: { BaseAlert },
})
